import { useOptimizelyFlag } from 'src/services/flags/hooks/useOptimizelyFlag';
import { usePaypalContext, useStripeContext } from '../contexts';
import { useIsPaypalVStripeVariantFlagEnabled } from './useIsPaypalVStripeVariantFlagEnabled';

/**
 * Redirect criteria:
 * - User is eligible for both Stripe and PayPal: display if both are INITIAL.
 * - User is eligible for only PayPal: display if PayPal is INITIAL.
 */
export function useShouldRedirectToLandingPage(): boolean {
  const isPaypalVStripeVariantEnabled = useIsPaypalVStripeVariantFlagEnabled();
  const { enabled: paymentsEnabled } = useOptimizelyFlag('payments_enabled');
  const { isStripeInitial, isStripeEligibleAndOptedIn } = useStripeContext() || {};
  const { isPaypalInitial } = usePaypalContext() || {};

  if (!paymentsEnabled) return false;

  if (!isPaypalInitial?.()) return false;

  const stripeInitial = isPaypalVStripeVariantEnabled && !!isStripeInitial;
  const stripeEligible = isPaypalVStripeVariantEnabled && !!isStripeEligibleAndOptedIn;

  return stripeInitial || !stripeEligible;
}
